export default __webpack_public_path__ + "static/media/MONICAs.9b3f004a.png";